/**
 *
 * SearchField
 *
 */

import React, { memo, FunctionComponent, CSSProperties } from 'react';
import { SearchFieldContainer } from './styledComponents';
import searchIcon from '../../assets/icons/search-icon.svg'

interface IProps {
  className?: string;
  onChange?: (v: string) => void;
  value?: string;
  placeholder?: string;
  style?: CSSProperties
}

const SearchField: FunctionComponent<IProps> = ({
  className,
  onChange,
  value,
  placeholder,
  style,
}) => {
  return (
    <SearchFieldContainer className={className} style={style}>
      <img src={searchIcon} alt="" />
      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        onChange={(e) => onChange && onChange(e.currentTarget.value)}
        value={value}
      />
      {value && (
        <button onClick={() => onChange?.('')} className="close-icon">
          &times;
        </button>
      )}
    </SearchFieldContainer>
  );
};

export default memo(SearchField);
